import { useContext } from 'react'
import { RemoteAssistanceControlsContext } from 'context/remoteAssistance'

const useRemoteAssistanceControls = () => {
  return useContext(RemoteAssistanceControlsContext)
}

export default useRemoteAssistanceControls
